module.exports = __webpack_public_path__ + "static/img/xcdown_white.c4e13c68.png";